import Departments from '../../../common/models/Departments';

export const isCategorySomeDepartment = (categoryName): boolean => {
  return (
    !categoryName ||
    Object.keys(Departments.names)
      .map(department => department.replace(/-/g, ' '))
      .includes(categoryName.toLowerCase())
  );
};

export const overrideCategory = (department, categoryName) => {
  const departmentWithoutDashes = department.replace(/-/g, ' ').toLowerCase();
  if (departmentWithoutDashes === categoryName.toLowerCase()) {
    return 'Clothing';
  }
  return categoryName;
};
